import React from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon } from '../../_components'
import Bio from './Sections/Bio'
import Location from './Sections/Location'
import data from '../../fixtures'
import NextOfKin from './Sections/NextOfKin'
import Leadership from './Sections/Leadership'
import Plot from './Sections/Plot'

export default function Form( { values, tag, details, handleChange, handleBlur, setPhone, setNOKPhone, setSecondaryContact, setCOPhone } ) {
  return (
    <>
    <Bio 
      tag={tag}
      details={details}
      values={values} handleChange={handleChange} handleBlur={handleBlur} data={data} 
      setPrimaryContact={(value) => { setPhone( value ) }}
      setSecondaryContact={(value) => { setSecondaryContact( value ) }} 
      setCOPhone={(value) => { setCOPhone( value ) }} />
    <Location tag={tag}
      details={details} values={values} handleChange={handleChange} handleBlur={handleBlur} data={data} />
    <NextOfKin tag={tag}
      setNOKPhone={(value) => { setNOKPhone( value ) }}
      details={details} values={values} handleChange={handleChange} handleBlur={handleBlur} />
    <Plot tag={tag}
      details={details} values={values} handleChange={handleChange} handleBlur={handleBlur} data={data}/>
    <Leadership tag={tag}
      details={details} values={values} handleChange={handleChange} handleBlur={handleBlur} data={data} />
    </>
  )
}
